import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import Typography from '@material-ui/core/Typography'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
//import Input from '@material-ui/core/Input'
import Checkbox from '@material-ui/core/Checkbox'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'

import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { connect } from 'react-redux'

import { handleSaveOffice } from '../../actions/offices'
//import { saveOfficeData } from '../../utils/api'
//import { officeStatuses } from '../../utils/_DATA'
import { officeTypes } from '../../utils/_DATA'
import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '300px',
    maxWidth: '400px',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  currencyFormControl: {
    marginTop: '16px'
  },
  sectionTitle: {
    marginTop: '15px',
    marginBottom: '10px',
    fontWeight: '500'
  },
  formHyphen: {
    textAlign: 'center',
    marginTop: '22px'
  },
  formSuffix: {
    marginLeft: '10px',
    marginTop: '33px'
  }
});

class GeneralInfoDialog extends Component {
  state = {
    name: '',
    totalArea: '',
    workStations: '',
    availability: '',
    minLeaseTermFrom: '',
    minLeaseTermTo: '',
    parkingSurface: '',
    parkingRoofed: '',
    parkingUnderground: '',
    parkingGarage: '',
    typeId: '',
    statusId: '',
    openingDate: '',
    website: '',
    showOnWebsite: ''
  }

  componentDidMount() {
    const { data } = this.props

    //console.log(data)

    this.setState(() => ({
      name: data.name,
      totalArea: data.totalArea,
      workStations: data.workStations !== null ? data.workStations : '',
      availability: data.availability !== null ? data.availability : '',
      minLeaseTermFrom: data.minLeaseTermFrom !== null ? data.minLeaseTermFrom : '',
      minLeaseTermTo: data.minLeaseTermTo !== null ? data.minLeaseTermTo : '',
      parkingSurface: data.numberOfParkings.surface !== null ? data.numberOfParkings.surface : '',
      parkingRoofed: data.numberOfParkings.roofed !== null ? data.numberOfParkings.roofed : '',
      parkingUnderground: data.numberOfParkings.underground !== null ? data.numberOfParkings.underground : '',
      parkingGarage: data.numberOfParkings.garage !== null ? data.numberOfParkings.garage : '',
      typeId: data.typeId !== null ? data.typeId : '',
      statusId: data.statusId !== null ? data.statusId : '',
      openingDate: data.openingDate !== null ? data.openingDate : '',
      website: data.website !== null ? data.numberwebsiteOfFloors : '',
      showOnWebsite: data.showOnWebsite !== null ? data.showOnWebsite : ''
    }))
  }

  handleChangeName = e => {
    const name = e.target.value

    this.setState(() => ({
      name
    }))
  }

  handleChangeTotalArea = e => {
    const totalArea = e.target.value

    this.setState(() => ({
      totalArea
    }))
  }

  handleChangeWorkStations = e => {
    const workStations = e.target.value

    this.setState(() => ({
      workStations
    }))
  }

  handleChangeAvailability = e => {
    const availability = e.target.value

    this.setState(() => ({
      availability
    }))
  }

  handleChangeMinLeaseTermFrom = e => {
    const minLeaseTermFrom = e.target.value

    this.setState(() => ({
      minLeaseTermFrom
    }))
  }

  handleChangeMinLeaseTermTo = e => {
    const minLeaseTermTo = e.target.value

    this.setState(() => ({
      minLeaseTermTo
    }))
  }

  handleChangeParkingSurface = e => {
    const parkingSurface = e.target.value

    this.setState(() => ({
      parkingSurface
    }))
  }

  handleChangeParkingRoofed = e => {
    const parkingRoofed = e.target.value

    this.setState(() => ({
      parkingRoofed
    }))
  }

  handleChangeParkingUnderground = e => {
    const parkingUnderground = e.target.value

    this.setState(() => ({
      parkingUnderground
    }))
  }

  handleChangeParkingGarage = e => {
    const parkingGarage = e.target.value

    this.setState(() => ({
      parkingGarage
    }))
  }

  /*handleChangeTypes = value => () => {
    const { types } = this.state;
    const currentIndex = types.indexOf(value);
    const newTypes = [...types];

    if (currentIndex === -1) {
      newTypes.push(value);
    } else {
      newTypes.splice(currentIndex, 1);
    }

    this.setState({
      types: newTypes,
    });
  };*/

  handleChangeType = e => {
    const typeId = e.target.value

    this.setState(() => ({
      typeId
    }))
  }

  handleChangeStatus = e => {
    const statusId = e.target.value

    this.setState(() => ({
      statusId
    }))
  }

  handleChangeOpeningDate = e => {
    const openingDate = e.target.value

    this.setState(() => ({
      openingDate
    }))
  }

  handleChangeWebsite = e => {
    const website = e.target.value

    this.setState(() => ({
      website
    }))
  }

  handleChangeVisibility = e => {
    const showOnWebsite = e.target.checked

    this.setState(() => ({
      showOnWebsite: showOnWebsite ? '1' : '0'
    }))
  }

  handleSaveData = e => {
    const { officeId, handleClose, dispatch } = this.props
    const data = JSON.stringify(this.state)

    //console.log(data)

    dispatch(handleSaveOffice(officeId, data))

    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    const { name, totalArea, workStations, availability, minLeaseTermFrom, minLeaseTermTo, openingDate, website, showOnWebsite, typeId } = this.state
    const { parkingSurface, parkingRoofed, parkingUnderground, parkingGarage } = this.state

    const lang = 'en'

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Edit general information</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="name"
                  label={t[lang].name}
                  value={name}
                  onChange={this.handleChangeName}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="totalArea"
                  label={t[lang].totalArea}
                  value={totalArea}
                  onChange={this.handleChangeTotalArea}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="workStations"
                  label={t[lang].workStations}
                  value={workStations}
                  onChange={this.handleChangeWorkStations}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="availability"
                  label={t[lang].availability}
                  value={availability}
                  onChange={this.handleChangeAvailability}
                />
              </FormControl>

              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].minLeaseTerm}
              </Typography>

              <Grid container>
                <Grid item xs={4}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="minLeaseTermFrom"
                      label={t[lang].from}
                      value={minLeaseTermFrom}
                      onChange={this.handleChangeMinLeaseTermFrom}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1}>
                  <Typography className={classes.formHyphen}>–</Typography>
                </Grid>
                <Grid item xs={4}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="minLeaseTermTo"
                      label={t[lang].to}
                      value={minLeaseTermTo}
                      onChange={this.handleChangeMinLeaseTermTo}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <Typography className={classes.formSuffix}>{t[lang].days}</Typography>
                </Grid>
              </Grid>

              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].numberOfParkings}
              </Typography>

              <Grid container>
                <Grid item xs={5}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="parkingSurface"
                      label={t[lang].parkingSurface}
                      value={parkingSurface}
                      onChange={this.handleChangeParkingSurface}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={5}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="parkingRoofed"
                      label={t[lang].parkingRoofed}
                      value={parkingRoofed}
                      onChange={this.handleChangeParkingRoofed}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="parkingUnderground"
                      label={t[lang].parkingUnderground}
                      value={parkingUnderground}
                      onChange={this.handleChangeParkingUnderground}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={5}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="parkingGarage"
                      label={t[lang].parkingGarage}
                      value={parkingGarage}
                      onChange={this.handleChangeParkingGarage}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/*<Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].type}
              </Typography>

              <FormGroup row className={classes.formControl}>
                {Object.values(officeTypes[lang]).map(t => (
                  <FormControlLabel
                    key={t.id}
                    control={
                      <Checkbox
                        checked={types.indexOf(t.id) !== -1}
                        onChange={this.handleChangeTypes(t.id)}
                        tabIndex={-1}
                        disableRipple
                        value={t.id.toString()}
                      />
                    }
                    label={t.title}
                  />
                ))}
              </FormGroup>*/}

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="statusId">{t[lang].type}</InputLabel>
                <Select
                  id="typeId"
                  value={typeId}
                  onChange={this.handleChangeType}
                  name="typeId"
                >
                  {officeTypes[lang].map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/*<FormControl className={classes.formControl}>
                <InputLabel htmlFor="statusId">Status</InputLabel>
                <Select
                  id="statusId"
                  value={statusId}
                  onChange={this.handleChangeStatus}
                  name="statusId"
                >
                  {officeStatuses[lang].map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>*/}

              <FormControl className={classes.formControl}>
                <TextField
                  id="openingDate"
                  label={t[lang].openingDate}
                  value={openingDate}
                  type="date"
                  format={'YYYY-MM-DD'}
                  onChange={this.handleChangeOpeningDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="website"
                  label={t[lang].website}
                  value={website}
                  onChange={this.handleChangeWebsite}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showOnWebsite === '1'}
                      onChange={this.handleChangeVisibility}
                      value={t[lang].showOnWebsite}
                      color={showOnWebsite === '1' ? 'secondary' : 'default'}
                    />
                  }
                  label={t[lang].showOnWebsite}
                />
              </FormControl>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

GeneralInfoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(GeneralInfoDialog)))


// WEBPACK FOOTER //
// ./src/components/Offices/GeneralInfoDialog.js